import React, { useEffect, useState } from "react";
// import profileImg from "src/Assets/images/profileImg.png"
import Edit from "src/Assets/images/edit.svg";
import Delete from "src/Assets/images/Delete.svg";
// import Paper from "src/Assets/images/paper.svg"
// import DownArrow from "src/Assets/images/UpButton.png";
// import dot from "src/Assets/images/dot.png";
// import location from "src/Assets/images/userlocationtag.png";
import saysoutlineimage from "src/Assets/images/noofsays.svg";
import follow from "src/Assets/images/follow.svg";
import unfollow from "src/Assets/images/unfollow.svg";
// import like from "src/Assets/images/like.png";
// import unlike from "src/Assets/images/unlike.png";
import { Avatar, Typography } from "@mui/material";
import ChildSay from "./Activites/ChildSay";
import activityStyle from "src/Assets/css/Activity/activity.module.css";
import { MdKeyboardArrowDown } from "react-icons/md";
import Location from "src/Assets/images/locationpin.png";
import API from "../../network";
import { useSelector } from "react-redux";
import ReusuableSendaMailModal from "../../Modules/Reusuablecomponents/ReusuableSendaMailModal";
import ReusuableReportDialogmodal from "../../Modules/Reusuablecomponents/ReusuableReportDialogmodal";
import SimpleDialogDemo from "../../Modules/Reusuablecomponents/CustomizedDialogs";
import shareIcon from "src/Assets/images/update-sare-icon.png";
import unShareIcon from "src/Assets/images/update-unsare-icon.png";
import IconButton from "@material-ui/core/IconButton";
import { Menu, MenuItem } from "@szhsin/react-menu";
import PostMessageValidation from "../Reusuablecomponents/PostMessageValidation";
import AvatarBadge from "src/Components/AvatarBadge";
import AsksModal from "../../pages/HomePage/components/AsksModal";
import ReusuableDeleteDialogmodal from "../Reusuablecomponents/ReusuableDeleteModal";
import TextWithUrlsAndHashTags from "src/Components/TextWithUrlsAndHashTags";
import dot from "src/Assets/images/dot.png";
import MapDialog from "../../pages/HomePage/components/LocationAddress";
import { ProfileHoverCard } from "src/pages/HomePage/components/ProfileHoverCard";
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import ConfirmationDialog from "src/Components/ConfirmationDialog";
import replyIcon from "src/Assets/images/message new icon.png";
import answerIcon from "src/Assets/images/answerIcon.png";
import PostAttachmentViewer from "src/Utils/PostAttachmentViewer";
import { PiDotsThreeBold } from "react-icons/pi";
import Tooltip from "@mui/material/Tooltip";
import ReusuableTagActionModal from "src/Utils/ReusuableTagActionModal";
import alreadyImpactfulMemberImg from "src/Assets/images/already_impactful_img.png";

function ActivityPost(props) {
  const {
    decreaseHashCount,
    deleteActivityTagPost,
    decreaseActivityAskCount,
    onHashTagClick,
    deleteActivityAskPost,
    setPageNumber,
    getData,
    handleDeleteAttachementDocFromParent,
    updateIsOpeASkStatus,
  } = props;
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);
  const profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;
  const [editId, setEditID] = useState(null);
  const [childSayId, setChildSayId] = useState(null);
  const [listData, setListData] = useState([]);
  const [answersToYourAsk, setAnswersToYourAsk] = useState({});
  const [SaysShow, setSaysShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messageId, setMessageId] = useState(null);
  const [openMap, setOpenMap] = useState(false);
  const [showUnfollowAlert, setShowUnfollowAlert] = useState(null);
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [isAttacmentDeleted, setIsAttacmentDeleted] = useState(null);
  const [messageConnectionStatus, setMessageConnectionStatus] = useState("");

  const [clickedLocation, setClickedLocation] = useState({
    locAddress: "",
    latitude: "",
    longitude: "",
  });

  useEffect(() => {
    setListData(props.listData);
  }, [props.pageNumber, props.listData]);

  const getListData = () => {
    setListData([]);
    setPageNumber && setPageNumber(1);
    getData && getData(1);
  };

  const handleClickOpen = (address, lat, lng) => {
    setOpenMap(true);
    setClickedLocation({
      locAddress: address,
      latitude: lat,
      longitude: lng,
    });
  };
  const handleCloseMap = () => {
    setOpenMap(false);
  };

  const followunfollow = (id, followstatus, filterType) => {
    if (followstatus === "isFollow=0") {
      setShowUnfollowAlert({
        id,
        followstatus,
      });
    } else {
      followunfollowCallback(id, followstatus);
    }
  };

  const followunfollowCallback = (id, followstatus) => {
    props.updateList(id, followstatus);

    let formData = new FormData();
    formData.append("messageID", id);
    formData.append("isFollow", parseInt(followstatus.split("=")[1], 10));

    API.activityFollowUnfollowData(formData);
    decreaseHashCount && decreaseHashCount();
    decreaseActivityAskCount && decreaseActivityAskCount();
    deleteActivityTagPost && deleteActivityTagPost(id);
    deleteActivityAskPost && deleteActivityAskPost(id);
  };

  const onLikeUnlikeSelection = (id, cache) => {
    props.likeUnlike(id);
    API.fetchVoteUpStatus(id, cache);
  };

  const handleDeleteAttachementDoc = async (id) => {
    try {
      const response = await API.deleteAttachment(id);

      if (response?.data?.status === "success") {
        alert("Attachment deleted successfully!");

        // Update UI immediately without mutating state
        setListData((prevData) =>
          prevData.map((item) =>
            item.id === id
              ? { ...item, docName: null, docLocation: null, docTagged: 0 }
              : item,
          ),
        );
        setIsAttacmentDeleted(response?.data?.status);
        handleDeleteAttachementDocFromParent &&
          handleDeleteAttachementDocFromParent(id);
      }
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete attachment.");
    } finally {
      setActiveTooltip(null);
    }
  };

  const fetchVoteUpStatus = async (id, status) => {
    try {
      await API.fetchVoteUpStatus(id, status);
    } catch (e) {
      console.error(e);
    }
  };

  const onHideAsksModal = () => {
    setSaysShow(false);
  };

  const updateMessage = (id, message, locationName, attachment, lat, lng) => {
    const tempUrl =
      attachment instanceof File ? URL.createObjectURL(attachment) : null;
    const urlRegex =
      /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9-]+\.(com|org|net|io|co|in|edu|gov|me|info|biz|dev|app|store|tech)[^\s]*)/gi;
    const extractedUrls = message ? message.match(urlRegex) || [] : [];

    setListData((prevList) =>
      prevList.map((eachItem) => {
        if (eachItem?.id === id) {
          const { newSelectedLocation, ...cleanItem } = eachItem;
          const cleanUpdatedMsg = (message || "").replace(/<[^>]+>/g, "").trim();
          const cleanDefaultMsg = (eachItem?.Message || "").replace(/<[^>]+>/g, "").trim();
          const isTextModified = cleanUpdatedMsg.length > 0 && cleanUpdatedMsg !== cleanDefaultMsg;
          const isAttachmentAdded = attachment instanceof File;
          const isContentEdited = isTextModified || isAttachmentAdded;

          return {
            ...cleanItem,
            Message: message,
            msg: message,
            url: extractedUrls.length > 0 ? extractedUrls : eachItem?.url,
            locName: locationName || "",
            msgLat: locationName ? (lat || eachItem.msgLat || "") : "",
            msgLng: locationName ? (lng || eachItem.msgLng || "") : "",
            docName:
              attachment?.name ||
              (attachment === null ? "" : eachItem.docName || ""),
            docLocation:
              tempUrl ||
              (attachment === null ? "" : eachItem.docLocation || ""),
            docTagged:
              attachment ? 1 : attachment === null ? 0 : eachItem.docTagged,
            ...(isContentEdited ? { updated_time: "1m", edited: 1 } : {}),
          };
        }
        return eachItem;
      })
    );
    props.updateMessage &&
      props.updateMessage(id, message, locationName, attachment, lat, lng);
    setEditID(null);
  };

  const cancelEdit = () => {
    removeNewSelectedLocationKey();
    setEditID(null);
  };

  const onShareUnshare = (id, shareStatus) => {
    const newStatus = shareStatus === "1" ? "N" : "Y";
    const newListData = listData.map((item) => {
      if (item.id === id) {
        return { ...item, announceStatus: newStatus };
      } else {
        return item;
      }
    });
    setListData(newListData);
    API.shareUnshareUpdate(id, shareStatus);
  };

  const updateSayCount = (parentId, operator) => {
    setListData((prevList) =>
      prevList.map((item) => {
        if (item.id !== parentId) return item; // unchanged item

        const filterType = props?.filterType;
        const key = filterType === "activityTag" ? "postCount" : "sayCount";
        const count = item[key] || 0;

        let newCount = count;
        if (operator === "increment") {
          newCount = count + 1;
        } else if (operator === "decrement") {
          newCount = Math.max(0, count - 1); // prevent negative
        }

        return { ...item, [key]: newCount };
      }),
    );
    props.updateParentComponentSayCount(parentId, operator, props.filterType);
  };

  const askYourCommunity = async (id) => {
    try {
      const res = await API.askYourCommunity(id);
      if (res?.data?.Status === "OK" && messageConnectionStatus === "A") {
        updateIsOpeASkStatus && updateIsOpeASkStatus(id);
      }
      if (messageConnectionStatus === "E") {
        deleteActivityAskPost && deleteActivityAskPost(id);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchSaysDataForAsks = async (page, id) => {
    setLoading(true);
    try {
      console.log(`activity post Id:`, id);
      const formdata = new FormData();
      formdata.append("id", id);
      const response = await API.fetchAsksSearchResultData(page, formdata);
      const updatedData = {
        ...response.data,
        messageConnectionID: id,
      };
      setAnswersToYourAsk({ answersToYourAsk: updatedData });
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  };

  const postAskHandler = (
    Message,
    msgLat,
    msgLng,
    locName,
    id,
    messageRestrictionStatus,
  ) => {
    // let formData = new FormData();
    let lnglat;
    const postingOption = "";
    if ((msgLat !== "") & (msgLng !== "")) {
      lnglat = msgLat + "," + msgLng;
    } else {
      lnglat = "";
    }
    fetchSaysDataForAsks(0, id);
    setSaysShow(true);
    setMessageId(id);
    setMessageConnectionStatus(messageRestrictionStatus);

    // setTimeout(() => {
    //   fetchContributors && fetchContributors();
    //   dispatch(SignInActions.fetchloginUser());
    // }, 1000);
  };

  const updateNewSelectedLocation = (newSelectedLoc) => {
    setListData((prevList) =>
      prevList.map((x) =>
        x.id === editId ? { ...x, newSelectedLocation: newSelectedLoc } : x
      )
    );
  };

  const removeNewSelectedLocationKey = () => {
    setListData((prevList) =>
      prevList.map((item) => {
        const { newSelectedLocation, ...rest } = item;
        return rest;
      })
    );
  };

  return (
    <>
      {listData.map((result) => (
        <div className={activityStyle.activityPostCard} key={result.id}>
          <div className="profile-info">
            {result.Keyword_ID === "hashTagFollow" ? (
              <div
                className={activityStyle.activityPostImageDropdownMainContainer}
              >
                <div
                  className={activityStyle.activityPostImageProfileContainer}
                >
                  <div className={activityStyle.profileimg}>
                    <div className={feedstyles.avatarContainer}>
                      <AvatarBadge
                        src={`${profileImagePath}${result?.mainuserdata?.uimage}`}
                        alt={result?.mainuserdata?.displayName}
                        isPrimaryModerator={
                          result?.mainuserdata?.isPM == 1 &&
                          result?.mainuserdata?.isModerator == 1
                        }
                        isModerator={
                          result?.mainuserdata?.isModerator == 1 &&
                          result?.mainuserdata?.isPM == 0
                        }
                      />
                      <ProfileHoverCard
                        result={result}
                        filterType={props?.filterType}
                        isActionDisabled={props.isActionDisabled}
                      />
                    </div>
                  </div>
                  <div
                    style={{ flex: 1 }}
                    className={activityStyle.profilename}
                  >
                    <span
                      className={feedstyles.profilename}
                      style={{ display: "flex" }}
                    >
                      <p className={feedstyles.profilehovername}>
                        {result?.mainuserdata?.displayName}
                      </p>
                      {result?.mainuserdata?.isImpactableMember === "yes" && (
                        <img
                          src={alreadyImpactfulMemberImg}
                          alt="Impactful Member"
                          title="Impactful Member"
                          style={{
                            width: "18px",
                            height: "18px",
                            objectFit: "contain",
                            flexShrink: 0,
                            marginLeft: "-4px",
                          }}
                        />
                      )}
                    </span>
                    <div className={activityStyle.timeLocationContainer}>
                      <span
                        className={
                          result.locName
                            ? activityStyle.tenantAndTimeName
                            : activityStyle.tenantAndTimeNameWithoutLocation
                        }
                      >
                        {result.Message_Time}{" "}
                        {result.edited === 1 && (
                          <span> (edited {result.updated_time})</span>
                        )}{" "}
                        in{" "}
                        <Tooltip title={result.Tenant_name} arrow>
                          {result.Tenant_name}
                        </Tooltip>
                      </span>
                      {/* {(result.locName==="")?null: result.locName} */}
                      {(result.locName || result.newSelectedLocation) && (
                        <span className={activityStyle.locationContainer}>
                          <img
                            src={dot}
                            alt="dot"
                            className={activityStyle.dotImg}
                          />
                          <img
                            src={Location}
                            alt=""
                            className={activityStyle.locationIconImg}
                            onClick={() =>
                              handleClickOpen(
                                result.locName,
                                result.msgLat,
                                result.msgLng,
                              )
                            }
                          />
                          <span
                            className={activityStyle.locationContent}
                            onClick={() =>
                              handleClickOpen(
                                result.locName,
                                result.msgLat,
                                result.msgLng,
                              )
                            }
                          >
                            {result.newSelectedLocation || result.locName}
                          </span>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className={
                    activityStyle.activityPostCardImagePopupMainContainer
                  }
                >
                  <Menu viewScroll="close" position="anchor" reposition="auto"
                    menuButton={
                      <IconButton
                        style={{
                          padding: 0,
                          width: 30,
                          height: 30,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          outline: "none",
                        }}
                        disabled={
                          result.communityFollowStatus === 0 &&
                          result.tenantType === "private"
                        }
                      >
                        {/* <MdKeyboardArrowDown fontSize={25} /> */}
                        <PiDotsThreeBold
                          fontSize={25}
                          color="rgba(0, 0, 0, 0.7)"
                        />
                      </IconButton>
                    }
                    transition
                    direction="bottom"
                    arrow
                    menuStyle={{
                      backgroundColor: "white",
                      borderRadius: 20,
                    }}
                    align="end"
                  >
                    {result.Keyword_ID === "hashTagFollow" && (
                      <MenuItem>
                        <ReusuableTagActionModal
                          type="download"
                          tagId={result?.id}
                          tagName={result?.Message}
                          tagData={result}
                        />
                      </MenuItem>
                    )}
                    {result.Keyword_ID === "hashTagFollow" && (
                      <MenuItem>
                        <ReusuableTagActionModal
                          type="rating"
                          tagId={result?.id}
                          tagName={result?.Message}
                          tagData={result}
                        />
                      </MenuItem>
                    )}
                    {result.User_ID !== userDetails?.userData?.User_ID ? (
                      <>
                        {result.moderatorStatus === "1" ? (
                          <>
                            <MenuItem>
                              <ReusuableDeleteDialogmodal
                                label={"Delete Post"}
                                type={props?.postType}
                                id={result.id}
                                deleteMessage={() =>
                                  props?.onDelete && props.onDelete(result.id)
                                }
                                fetchContributors={() => {}}
                              />
                            </MenuItem>
                            <MenuItem>
                              <ReusuableSendaMailModal
                                displayName={result.displayName}
                                id={result.id}
                                notificationStatus={
                                  result.mainuserdata.notificationStatus
                                }
                              />
                            </MenuItem>
                          </>
                        ) : (
                          <>
                            <MenuItem>
                              <ReusuableReportDialogmodal
                                id={result.id}
                                param={"AskorSay"}
                              />
                            </MenuItem>
                            <MenuItem>
                              <ReusuableSendaMailModal
                                displayName={result.displayName}
                                id={result.id}
                                notificationStatus={
                                  result.mainuserdata.notificationStatus
                                }
                              />
                            </MenuItem>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <MenuItem onClick={() => setEditID(result.id)}>
        <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
          <img src={Edit} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="edit" />
          <span style={{ fontSize: 14, whiteSpace: "nowrap" }}>Edit Post</span>
        </div>
      </MenuItem>
                        <MenuItem>
                          <ReusuableDeleteDialogmodal
                            label={"Delete Post"}
                            type={props?.postType}
                            id={result.id}
                            deleteMessage={() =>
                              props?.onDelete && props.onDelete(result.id)
                            }
                            fetchContributors={() => {}}
                          />
                        </MenuItem>
                      </>
                    )}
                  </Menu>
                </div>
              </div>
            ) : (
              <div
                className={activityStyle.activityPostImageDropdownMainContainer}
              >
                <div
                  className={activityStyle.activityPostImageProfileContainer}
                >
                  <div className={activityStyle.profileimg}>
                    <div className={feedstyles.avatarContainer}>
                      <AvatarBadge
                        src={`${profileImagePath}${result?.mainuserdata?.uimage}`}
                        alt={result?.mainuserdata?.displayName}
                        isPrimaryModerator={
                          result?.mainuserdata?.isPM == 1 &&
                          result?.mainuserdata?.isModerator == 1
                        }
                        isModerator={
                          result?.mainuserdata?.isPM == 0 &&
                          result?.mainuserdata?.isModerator == 1
                        }
                      />
                      <ProfileHoverCard
                        result={result}
                        filterType={props?.filterType}
                        isActionDisabled={props.isActionDisabled}
                      />
                    </div>
                  </div>
                  <div
                    style={{ flex: 1 }}
                    className={activityStyle.profilename}
                  >
                    <span
                      className={feedstyles.profilename}
                      style={{ display: "flex" }}
                    >
                      <p className={feedstyles.profilehovername}>
                        {result?.mainuserdata?.displayName}
                      </p>
                      {result?.mainuserdata?.isImpactableMember === "yes" && (
                        <img
                          src={alreadyImpactfulMemberImg}
                          alt="Impactful Member"
                          title="Impactful Member"
                          style={{
                            width: "18px",
                            height: "18px",
                            objectFit: "contain",
                            flexShrink: 0,
                            marginLeft: "-4px",
                          }}
                        />
                      )}
                    </span>
                    <div className={activityStyle.timeLocationContainer}>
                      <span
                        className={
                          result.locName
                            ? activityStyle.tenantAndTimeName
                            : activityStyle.tenantAndTimeNameWithoutLocation
                        }
                      >
                        {result.Message_Time}{" "}
                        {result.edited === 1 && (
                          <span> (edited {result.updated_time})</span>
                        )}{" "}
                        in{" "}
                        <Tooltip title={result.Tenant_name} arrow>
                          {result.Tenant_name}
                        </Tooltip>
                      </span>
                      {(result.locName || result.newSelectedLocation) && (
                        <span className={activityStyle.locationContainer}>
                          <img
                            src={dot}
                            alt="dot"
                            className={activityStyle.dotImg}
                          />
                          <img
                            src={Location}
                            alt=""
                            className={activityStyle.locationIconImg}
                            onClick={() =>
                              handleClickOpen(
                                result.locName,
                                result.msgLat,
                                result.msgLng,
                              )
                            }
                          />
                          <span
                            className={activityStyle.locationContent}
                            onClick={() =>
                              handleClickOpen(
                                result.locName,
                                result.msgLat,
                                result.msgLng,
                              )
                            }
                          >
                            {result.newSelectedLocation || result.locName}
                          </span>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className={
                    activityStyle.activityPostCardImagePopupMainContainer
                  }
                >
                  <Menu viewScroll="close" position="anchor" reposition="auto"
                    menuButton={
                      <IconButton
                        style={{
                          padding: 0,
                          width: 30,
                          height: 30,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          outline: "none",
                        }}
                        disabled={
                          result.communityFollowStatus === 0 &&
                          result.tenantType === "private"
                        }
                      >
                        {/* <MdKeyboardArrowDown fontSize={25} /> */}
                        <PiDotsThreeBold
                          fontSize={25}
                          color="rgba(0, 0, 0, 0.7)"
                        />
                      </IconButton>
                    }
                    transition
                    direction="bottom"
                    arrow
                    menuStyle={{
                      backgroundColor: "white",
                      borderRadius: 20,
                    }}
                    align="end"
                  >
                    {(result.User_ID ?? result.userDetails?.User_ID) !==
                    userDetails?.userData?.User_ID ? (
                      <>
                        {result.moderatorStatus === "1" ? (
                          <>
                            <MenuItem>
                              <ReusuableDeleteDialogmodal
                                label={"Delete Post"}
                                type={props?.postType}
                                id={result.id}
                                deleteMessage={() =>
                                  props?.onDelete && props.onDelete(result.id)
                                }
                                fetchContributors={() => {}}
                              />
                            </MenuItem>
                            <MenuItem>
                              <ReusuableSendaMailModal
                                displayName={result.userDetails.displayName}
                                id={result.id}
                                notificationStatus={
                                  result.mainuserdata.notificationStatus
                                }
                              />
                            </MenuItem>
                          </>
                        ) : (
                          <>
                            <MenuItem>
                              <ReusuableReportDialogmodal
                                id={result.id}
                                param={"AskorSay"}
                              />
                            </MenuItem>
                            <MenuItem>
                              <ReusuableSendaMailModal
                                displayName={result.userDetails.displayName}
                                id={result.id}
                                notificationStatus={
                                  result.mainuserdata.notificationStatus
                                }
                              />
                            </MenuItem>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <MenuItem onClick={() => setEditID(result.id)}>
        <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
          <img src={Edit} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="edit" />
          <span style={{ fontSize: 14, whiteSpace: "nowrap" }}>Edit Post</span>
        </div>
      </MenuItem>
                        <MenuItem>
                          <ReusuableDeleteDialogmodal
                            label={"Delete Post"}
                            type={props?.postType}
                            id={result.id}
                            deleteMessage={() =>
                              props?.onDelete && props.onDelete(result.id)
                            }
                            fetchContributors={() => {}}
                          />
                        </MenuItem>
                      </>
                    )}
                  </Menu>
                </div>
              </div>
            )}
          </div>
          <>
            <div className={activityStyle.activityPostDescriptionContainer}>
              {editId === result?.id ? (
                <PostMessageValidation
                  id={result.id}
                  Message={result.Message}
                  messageType={"feedTextArea"}
                  filtertype={props?.filterType}
                  post={result}
                  onCloseEdit={cancelEdit}
                  onMessagedUpdated={updateMessage}
                  latitude={result.msgLat}
                  longitude={result.msgLng}
                  locationAddress={result.locName}
                  updateNewSelectedLocation={updateNewSelectedLocation}
                  removeNewSelectedLocationKey={removeNewSelectedLocationKey}
                  onDeleteAttachment={handleDeleteAttachementDoc}
                  isAttacmentDeleted={isAttacmentDeleted}
                  setIsAttacmentDeleted={setIsAttacmentDeleted}
                  docName={result?.docName}
                />
              ) : (
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "baseline", // aligns with text bottom
                    flexWrap: "wrap",
                    gap: "5px", // small gap between text and file name
                  }}
                >
                  <Typography whiteSpace="pre-wrap">
                    <TextWithUrlsAndHashTags
                      Message={result.Message}
                      text={result.msg}
                      urls={result.url}
                      hashtags={result.tag}
                      tagActivityTenantId={
                        props?.filterType === "activityTag" ||
                        props?.filterType === "activityAsk"
                          ? result.Tenant_ID
                          : undefined
                      }
                      onHashtagClick={onHashTagClick}
                    />
                  </Typography>
                  <PostAttachmentViewer
                    docLocation={result.docLocation}
                    docTagged={result.docTagged}
                    docName={result.docName}
                    messageID={result.id}
                    activeTooltip={activeTooltip}
                    setActiveTooltip={setActiveTooltip}
                    onDeleteAttachment={handleDeleteAttachementDoc}
                  />
                </div>
              )}
            </div>
          </>

          {editId !== result?.id && (
            <>
            <div className="PostCounts">
            {result.Keyword_ID === "hashTagFollow" ||
            result.Keyword_ID === "actASK" ? (
              <>
                <SimpleDialogDemo
                  followCount={result?.followCount}
                  followData={result?.follweduserprofile}
                  id={result.id}
                  // status={followData}
                  hashTagType={result?.hashTagType}
                  isActionDisabled={props.isActionDisabled}
                />
              </>
            ) : (
              <>
                {" "}
                {result.voteUp !== 0 ? (
                  <SimpleDialogDemo
                    voteUp={result.voteUp}
                    id={result.id}
                    isVoteup={"true"}
                    isActionDisabled={props.isActionDisabled}
                  />
                ) : (
                  <span>
                    {result.voteUp === 1
                      ? `${result.voteUp} Like`
                      : `${result.voteUp} likes`}
                  </span>
                )}
              </>
            )}
            {result.communityFollowStatus === 0 &&
              result.tenantType === "private" && (
                <p className={activityStyle.activityPostWarning}>
                  This is a private Community, No action is permitted for non
                  member
                </p>
              )}
          </div>

          <div className="PostActions">
            {result.Keyword_ID === "hashTagFollow" ||
            result.Keyword_ID === "actASK" ? (
              <>
                {result?.isOpeASk === "0" && editId !== result?.id ? (
                  <div className={activityStyle.activityAskPostButtonContainer}>
                    <button
                      className={activityStyle.activityAskPostButton}
                      type="button"
                      onClick={() =>
                        postAskHandler(
                          result.Message,
                          result.msgLat,
                          result.msgLng,
                          result.locName,
                          result.id,
                          result?.messageConnectionStatus,
                        )
                      }
                    >
                      Post
                    </button>
                  </div>
                ) : (
                  <>
                    <div className="PostActions--Following">
                      <div
                        style={{ cursor: "pointer", marginTop: "3px" }}
                        onClick={(e) => {
                          if (
                            result.communityFollowStatus === 0 &&
                            result.tenantType === "private"
                          ) {
                            return; // Preventing the function from running
                          }
                          e.stopPropagation();
                          setChildSayId(
                            result.id === childSayId ? null : result.id,
                          );
                        }}
                      >
                        <img
                          src={
                            result.Keyword_ID === "actASK"
                              ? answerIcon
                              : replyIcon
                          }
                          className={
                            result.Keyword_ID === "actASK"
                              ? activityStyle.activityAnswerIcon
                              : activityStyle.activityReplyIcon
                          }
                          alt="number of says"
                        />
                        <span>
                          {(() => {
                            const count =
                              props?.filterType === "activityTag"
                                ? result?.postCount
                                : result?.sayCount;

                            const isActAsk = result.Keyword_ID === "actASK";
                            const singular = isActAsk ? "Answer" : "Reply";
                            const plural = isActAsk ? "Answers" : "Replies";

                            return count === 0
                              ? singular
                              : count === 1
                                ? `1 ${singular}`
                                : `${count} ${plural}`;
                          })()}
                        </span>
                      </div>
                      <div style={{ cursor: "pointer", marginTop: "3px" }}>
                        {result.followStatus === "Active" ||
                        result.followStatus === "Y" ? (
                          <div
                            id={`1${result.id}`}
                            onClick={(e) => {
                              if (
                                result.communityFollowStatus === 0 &&
                                result.tenantType === "private"
                              ) {
                                return; // Preventing the function from running
                              }
                              e.stopPropagation();
                              followunfollow(
                                result.id,
                                "isFollow=0",
                                props?.filterType,
                              );
                            }}
                          >
                            <img src={unfollow} alt="UnFolow" />
                            <span>Unfollow </span>
                          </div>
                        ) : (
                          <div
                            id={`0${result.id}`}
                            onClick={(e) => {
                              if (
                                result.communityFollowStatus === 0 &&
                                result.tenantType === "private"
                              ) {
                                return; // Preventing the function from running
                              }
                              e.stopPropagation();
                              followunfollow(
                                result.id,
                                "isFollow=1",
                                props?.filterType,
                              );
                            }}
                          >
                            <img src={follow} alt="Folow" />
                            <span>Follow </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                <div
                  style={{
                    cursor: "pointer",
                    marginTop: "5px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {result.announceStatus === "Y" ? (
                    <button
                      onClick={() => onShareUnshare(result.id, "1")}
                      className={activityStyle.activityPostButtonContainer}
                      type="button"
                      disabled={
                        result.communityFollowStatus === 0 &&
                        result.tenantType === "private"
                      }
                    >
                      <>
                        <img src={shareIcon} alt="shareImage" />
                        <p>Share</p>
                      </>
                    </button>
                  ) : (
                    <button
                      onClick={() => onShareUnshare(result.id, "0")}
                      className={activityStyle.activityPostButtonContainer}
                      type="button"
                      disabled={
                        result.communityFollowStatus === 0 &&
                        result.tenantType === "private"
                      }
                    >
                      <>
                        <img
                          src={unShareIcon}
                          alt="unShareImage"
                          style={{ height: "16px", marginRight: "5px" }}
                        />
                        <p style={{ marginBottom: "0px", fontSize: "14px" }}>
                          Unshare
                        </p>
                      </>
                    </button>
                  )}
                </div>
              </>
            )}
          </div>
          </>
        )}
          <div style={{ position: "relative" }}>
            {childSayId === result.id && (
              <ChildSay
                key={childSayId}
                id={result?.id}
                item={result}
                updateSayCount={updateSayCount}
                postType={"askOrTagActivity"}
              />
            )}
          </div>
        </div>
      ))}
      <MapDialog
        open={openMap}
        onClose={handleCloseMap}
        clickedLocation={clickedLocation}
        zoomLevel={12}
      />
      {showUnfollowAlert && (
        <ConfirmationDialog
          open={true}
          handleClose={() => setShowUnfollowAlert(null)}
          type={"warning"}
          title={"Are you sure you want to Unfollow?"}
          acceptLabel={"Yes"}
          onAccept={() => {
            followunfollowCallback(
              showUnfollowAlert?.id,
              showUnfollowAlert?.followstatus,
            );
            setShowUnfollowAlert(null);
          }}
        />
      )}
      <AsksModal
        loading={loading}
        // childSaysLoading={childSaysLoading}
        show={SaysShow}
        onHide={onHideAsksModal}
        isPostOption={"ASK"}
        askType={"ActivityAskPost"}
        // setPostOption={setPostOption}
        setSaysShow={setSaysShow}
        answersToYourAsk={answersToYourAsk?.answersToYourAsk}
        askActivityMessageRestrictionStatus={messageConnectionStatus}
        // asksToBeAnswered={asksToBeAnswered}
        askYourCommunity={askYourCommunity}
        messageId={messageId}
        getListData={getListData}
        // fetchFeedData={fetchFeedData}
        // postChildSayData={postChildSayData}
        // deleteMessage={deleteMessage}
        // filterPosts={filterPosts}
        // childSaysData={childSaysData}
        // fetchChildSaysData={fetchChildSaysData}
        // fetchFollowData={fetchFollowData}
        fetchVoteUpStatus={fetchVoteUpStatus}
        // deleteAnswersToAsksDialogPost={deleteAnswersToAsksDialogPost}
        // deleteAsksToBeAnsweredDialogPost={
        //   deleteAsksToBeAnsweredDialogPost
        // }
        // fetchContributors={fetchContributors}
        // onHashTagClick={onHashTagClick}
      />
    </>
  );
}

export default ActivityPost;
